module.exports = __webpack_public_path__ + "static/media/icon_red.60fc97ba.png";